export type FilterOption = {
    label: string; // display label for the filter option
    value: string; // actual value of the filter option
    urlId: string; // param value from the url (in most cases will be the same as value)
    tooltip?: string;
    apiKey?: string; // search-gateway param key used for mapping the FilterConfig key to the search-gateway param
};

export type AppliedFilter = {
    key: string;
    value: string;
    valueLabel: string;
    urlId?: string; // param value from the url
};

export type ExtraAppliedFilterConfig = {
    key: string;
    getValueLabel: (value: string) => string;
};

export type FilterConfig = {
    name: string;
    key: string;
    type: FilterTypes;
    options: FilterOption[];
    enableCondition?: (searchParams: URLSearchParams) => boolean;
    showText?: string;
};

export enum FilterTypes {
    RADIO_FILTER = 'RadioFilter',
    CHECKBOX_FILTER = 'CheckboxFilter',
    //COLOR_FILTER = 'ColorFilter',
    DRAG_BAR_FILTER = 'dragBarFilter',
}
